import type { ReactNode } from 'react';

export function Field({ label, children }: { label: string; children: ReactNode }) {
  return (
    <label className="block space-y-2">
      <span className="text-[0.64rem] font-semibold uppercase tracking-[0.22em] text-muted-foreground/50">{label}</span>
      {children}
    </label>
  );
}
